import store from '../../store'
import analytics from '../cdpAnalytics'

export function createRepoEvent(newRepo) {
  const state = store.getState()
  const { repos } = state

  let hasImage = false
  if (newRepo.image !== '') {
    hasImage = true
  }
  const repoName = newRepo.name
  const repoDescription = newRepo.description
  const repoCount = repos.length
  const repoId = newRepo.id

  analytics.track('Create New Repo', {
    hasImage,
    name: repoName,
    description: repoDescription,
    newRepoCount: repoCount,
    repoId,

  })
}
